import React, { createContext, useCallback, useContext, useState } from 'react';
import { Balance, Exhibitor, VoucherType } from '../dtos';

type State = {
    balances: Balance[];
    setBalances: React.Dispatch<React.SetStateAction<Balance[]>>;
    subtractDistributedBalanceAmount: (exhibitor: Exhibitor, type: VoucherType, amount: number) => void;
};

type Props = {
    children: React.ReactNode;
};

const BalanceContext = createContext<State>({} as State);

const BalanceProvider: React.FC<Props> = ({ children }) => {
    const [balances, setBalances] = useState<Balance[]>([]);

    const subtractDistributedBalanceAmount = useCallback((exhibitor: Exhibitor, type: VoucherType, amount: number) =>
        setBalances(oldBalances =>
            oldBalances.map(oldBalance => ({
                ...oldBalance,
                exhibitors: oldBalance.exhibitors.map(oldExhibitor => oldExhibitor.name === exhibitor.name ? ({
                    ...oldExhibitor,
                    voucherTypes: oldExhibitor.voucherTypes.map(oldVoucherType => oldVoucherType.name === type.name ? ({
                        ...oldVoucherType,
                        amount: oldVoucherType.amount - amount
                    }) : oldVoucherType)
                }) : oldExhibitor)
            }))), []);

    return (
        <BalanceContext.Provider
            value={{
                balances,
                setBalances,
                subtractDistributedBalanceAmount
            }}
        >
            {children}
        </BalanceContext.Provider>
    );
};

const useBalance = (): State => {
    const context = useContext(BalanceContext);

    return context;
}

export { BalanceProvider, useBalance };